import { render, staticRenderFns } from "./personalityCalibration.vue?vue&type=template&id=25590398&scoped=true"
import script from "./personalityCalibration.vue?vue&type=script&lang=js"
export * from "./personalityCalibration.vue?vue&type=script&lang=js"
import style0 from "./personalityCalibration.vue?vue&type=style&index=0&id=25590398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25590398",
  null
  
)

export default component.exports